/**
 * アクセス解析（GoatCounter）の設定。
 *
 * 使い方:
 *   1. https://www.goatcounter.com/ で無料アカウントを作成する
 *      （非営利利用は無料。Cookie を使わないので同意バナーは不要です）
 *   2. 登録時に決めたコード（例: igem-tsukuba）を使って、以下の URL を書き換える
 *        https://<自分のコード>.goatcounter.com/count
 *   3. main ブランチに push すると自動でデプロイされ、計測が始まります
 *   4. 集計は https://<自分のコード>.goatcounter.com/ で確認できます
 *
 * 空文字のままにしておくと計測スクリプトは一切読み込まれません。
 * 開発中（npm start）も計測されないようになっています。
 */
export const GOATCOUNTER_ENDPOINT: string =
  "https://igemtsukubastb.goatcounter.com/count";

/** 本番ビルドのときだけ計測する */
export const ANALYTICS_ENABLED =
  GOATCOUNTER_ENDPOINT !== "" && process.env.NODE_ENV === "production";
